'use strict';

angular.module('mobile-apps')
	.directive('mauCounter', ['ApiRequests', 'Mau', 'MobileAppMau', 'MobileAppLanguageMau', 'MobileAppIntegrationDone',
		function(ApiRequests, Mau, MobileAppMau, MobileAppLanguageMau, MobileAppIntegrationDone) {
			return {
				scope:
				{
					appId : '@',
					languageId : '@',
					maxValue : '=',
					mau : '='
				},
				templateUrl: 'modules/mobile-apps/views/mau-counter.client.view.html',

				link: function (scope, elem, attrs) {

					scope.displayData = {
						startIntegrationButton: false,
						mau: 'loading...',
						info: 'loading...'
					};

					scope.data = {
						mau: 0,
						apiRequests: 0
					};

					scope.labelText = 'MAU | API';

					scope.maxMauReached = false;


					/**
					 * Checks if the plan max values got reached
					 */
					function checkMaxReached() {

						if (isNaN(scope.maxValue)) {
							scope.maxValue = undefined;
						} else {
							scope.maxValue = parseInt(scope.maxValue);
							scope.labelText = 'MAU(+API) / Tier Limit';
						}

						var combinedCount = (scope.data.mau + scope.data.apiRequests);
						if (scope.maxValue && combinedCount > scope.maxValue) {
							scope.maxMauReached = true;
						} else {
							scope.maxMauReached = false;
						}
					}


					/**
					 * Sets the information to be displayed
					 */
					function setDisplayData() {
						if (scope.maxValue) {
							scope.displayData.info = (scope.data.mau + scope.data.apiRequests).toLocaleString() + ' / ' + scope.maxValue.toLocaleString();
						} else {
							scope.displayData.info = scope.data.mau.toLocaleString() + ' | ' + scope.data.apiRequests.toLocaleString();
						}
					}


					/**
					 * Gets the api requests
					 */
					function getApiRequests() {
						var successCallback = function(response) {
							scope.data.apiRequests = response.count;
							setDisplayData();
							checkMaxReached();
						};

						var errorCallback = function(response) {
							scope.data.apiRequests = 0;
							setDisplayData();
						};

						if (scope.appId && scope.appId !== 'all') {
							ApiRequests.app({
								mobileAppId: scope.appId
							}, successCallback, errorCallback);
						} else {
							ApiRequests.user({}, successCallback, errorCallback);
						}
					}


					/**
					 * Gets the mau
					 */
					function getMau() {
						var successCallback = function(response) {
							scope.data.mau = response.count;
							setDisplayData();
							checkMaxReached();
						};

						var errorCallback = function(response) {
							scope.data.mau = 0;
							setDisplayData();
						};

						if (scope.appId && scope.appId !== 'all') {
							if (scope.languageId) {
								// MAU of a specific language of an app
								MobileAppLanguageMau.get({
									mobileAppId: scope.appId,
									languageId: scope.languageId
								}, successCallback, errorCallback);
							} else {
								// MAU of App
								MobileAppMau.get({
									mobileAppId: scope.appId
								}, successCallback, errorCallback);
							}
						} else {
							// MAU of all user apps
							Mau.get({}, successCallback, errorCallback);
						}
					}


					/**
					 * Checks if the app got integrated already and if not
					 * displays an integration button
					 */
					function checkIntegrationDone() {
						if (scope.appId && scope.appId !== 'all' && !scope.languageId) {
							// If we have an appId but no languageId we want
							// to display a special button to remind people
							// to integrated their app if it has not done yet.
							// So check now if the integration has been done
							// already.
							MobileAppIntegrationDone.get({
								mobileAppId: scope.appId
							}, function (integrationResponse) {
								if (integrationResponse.integrated === true) {
									// App got already integrated
									scope.displayData.startIntegrationButton = false;
								} else {
									// App did NOT get integrated
									scope.displayData.startIntegrationButton = true;
								}
							}, function() {
								// If there was a problem with requesting
								// if the app got integrated we do not display
								// the button just to be sure
								scope.displayData.startIntegrationButton = false;
							});
						}
					}


					// Because we do not know if no maxValue got supplied or if
					// it just did not load yet we keep a watch on it to update
					// if a value appears later
					scope.$watch('maxValue', function() {
						checkMaxReached();
					});

					scope.init = function () {
						checkIntegrationDone();
						getApiRequests();

						// The value which gets displayed can either be given
						// directly as "mau" or it can be omitted and an appId
						// supplied. The mau will then get queried automatically.

						if (scope.appId === undefined) {
							var mauWatcher = scope.$watch('mau', function() {
								if (scope.mau !== undefined) {
									scope.data.mau = scope.mau;
									setDisplayData();
									checkMaxReached();
									mauWatcher();
								}
							});
							return;
						}

						getMau();
					};

					scope.init();
				}
			};
		}
	]);
